// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19_u4oGDr_SkvgZLjjWgf0 {\n  display: flex;\n  flex-direction: column;\n  line-height: var(--font-size7);\n  font-size: var(--font-size3-1);\n}\n\n._1ZER20vOM5B3Nj-huqifnc {\n  font-weight: var(--fw-light-bold);\n  margin: 0 0 var(--length4) 0;\n}\n\n._2NyMiqS7AYL--hDKKX2m8Q {\n  margin: 0;\n}\n\n._2xhVlVCO4WEIWqEYrfqNjc:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "_19_u4oGDr_SkvgZLjjWgf0",
	"title": "_1ZER20vOM5B3Nj-huqifnc",
	"body": "_2NyMiqS7AYL--hDKKX2m8Q",
	"consentButton": "_2xhVlVCO4WEIWqEYrfqNjc"
};
module.exports = exports;
